import { BaseModel } from './BaseModel';
import Operator, { OperatorType } from './Operator';

export interface User extends BaseModel {
  username: string;
  email?: string;
  nickname?: string;
  phone?: string;
  role?: string;
  permissions: string[];
  operatorId?: string;
  permission: UserPermission;
  userType: UserType;
  userLevel: number;
  lastLoginDate?: Date;
  modificationDate?: Date;
  deactivationDate?: Date;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  password: string;
  role: string;
  operatorId?: string;
  nickname?: string;
  phone?: string;
  userLevel?: number;
}

export interface UpdateUserRequest {
  username: string;
  email: string;
  role: string;
  operatorId?: string;
  nickname?: string;
  phone?: string;
  userLevel: number;
}

export interface ChangePasswordRequest {
  newPassword: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface RoleCatalogItem {
  name: string;
  permissions: string[];
}

export interface PermissionModuleItem {
  module: string;
  keys: string[];
}

export interface RolesCatalog {
  roles: RoleCatalogItem[];
  modules: PermissionModuleItem[];
}

export interface UserPermissionsEntry {
  userId: string;
  permissions: string[];
  role?: string;
}

export interface UpdateUserPermissionsRequest {
  users: UserPermissionsEntry[];
}

export interface UpdateUserPermissionsResponse {
  updatedCount: number;
  skippedUserIds: string[];
}

export const CUSTOM_ROLE = 'Custom';

export interface LoginUser {
  token: string;
  refreshToken: string;
  refreshTokenExpiryTime: Date;
  agentId: string;
  username: string;
  email?: string;
  permission: UserPermission;
  userType: UserType;
  role?: string;
  permissions: string[];
  operator?: Operator;
  userLevel?: number;
  impersonatorUsername?: string;
}

export enum UserPermission {
  Worker,
  OfficeUser,
  Administrator,
  SuperAdministrator,
  SpareParts,
  AdminCRM,
}

export enum UserType {
  Maintenance,
  Production,
  Warehouse,
  CRM,
  Quality,
}

export interface OperatorLogged {
  idOperatorLogged: string;
  codeOperatorLogged: string;
  nameOperatorLogged: string;
  operatorLoggedType: OperatorType;
}

export default User;
